import { render } from "./Questionnaire.vue?vue&type=template&id=61298ca9"
import script from "./Questionnaire.vue?vue&type=script&lang=ts"
export * from "./Questionnaire.vue?vue&type=script&lang=ts"
script.render = render

export default script